<template>
  <button type="button" @click="onClick">
    <div role="img" :class="{ 'eye': isEye, 'eye-slash': !isEye }" :aria-label="$T('file_request', 'eye_btn_alt')" />
  </button>
</template>

<script setup>
import { ref } from 'vue'
import { $T } from '@/utils/texts'

const props = defineProps({
  toggleable: {
    type: Boolean,
    default: true,
  },
});

const isEye = ref(true)
const emit = defineEmits(['click'])

const onClick = (event) => {
  if (props.toggleable) {
    isEye.value = !isEye.value
  }
  emit('click', event)
}

</script>

<style lang="scss" scoped>
@import '@/mixins/style.scss';

button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}

.eye {
  @include eye-icon-style('@/assets/trigger_visible.svg');
}

.eye-slash {
  @include eye-icon-style('@/assets/trigger_invisible.svg');
}

</style>
